import I from 'immutable'
import * as A from './actions'
import * as Env from 'domain/env'
import { Action } from 'redux'

interface ActionType extends Action {
  payload: any
}

const State = I.fromJS({
  educationsList: I.List(),
  education: I.Map()
})

export const reducer = {
  education(state = State, action: ActionType) {
    switch (action.type) {
      case A.educationsList.success:
        return state.set('educationsList', action.payload)
      case A.education.success:
        return state.set('education', action.payload)
      case Env.signOut.success:
        return State

      default:
        return state
    }
  }
}
